import React, { Component } from "react";
import PlaceholderImage1 from "../../../../Assets/svg/PlaceholderImage1.svg";
import IntentSVG from "../../../../Assets/svg/IntentSVG.svg";
import LanguageSVG from "../../../../Assets/svg/languageSVG.svg";
import SmileSVG from "../../../../Assets/svg/SmileSVG.svg";
import NeutralSVG from "../../../../Assets/svg/neutral.svg";
import SadSVG from "../../../../Assets/svg/sad-face.svg";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import PropType from "prop-types";
import {
  GetMessageSentiment,
  GetIndividualAIResponse,
  GenerateMessageSummary,
} from "../../../../Actions/Messaging";
import { X as CloseIcon } from "lucide-react";

class ShowMessageIntent extends Component {
  static propTypes = {
    GetMessageSentiment: PropType.func.isRequired,
    GenerateMessageSummary: PropType.func.isRequired,
    messageSentiment: PropType.object.isRequired,
    message: PropType.string,
    messageSentiment: PropType.object.isRequired,
    fetchedIndividualAIResponse: PropType.object,
    phone_number: PropType.string,
    messageSummaryForOverview: PropType.string,
    messageSummaryForOverSuccess: PropType.bool,
  };

  componentDidMount() {
    this.props.GetMessageSentiment(this.props.message);
    this.props.GetIndividualAIResponse(this.props.phone_number);
    this.props.GenerateMessageSummary(this.props.message);
  }

  navigateToMessage = (number) => {
    window.location.assign(`/#/dashboard/message-overview/whatsapp/${number}`);
  };

  renderSentimentSVG = (sentiment) => {
    switch (sentiment) {
      case "positive":
        return <img src={SmileSVG} alt="Smile" />;
      case "neutral":
        return <img src={NeutralSVG} alt="Neutral" />;
      case "negative":
        return <img src={SadSVG} alt="Sad" />;
      default:
        return <img src={NeutralSVG} alt="Neutral" />;
    }
  };

  render() {
    const {
      closeShowMessageIntent,
      showMessageHistory,
      showAIResponse,
      phone_number,
      messageSummaryForOverview,
    } = this.props;
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
        <div className="relative flex w-full max-w-4xl max-h-[90vh] flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
          {/* Header */}
          <div className="flex items-center justify-between border-b border-blue-200 bg-white px-6 py-4 text-gray-900">
            <div className="flex items-center gap-3">
              <img
                src={PlaceholderImage1}
                alt="Contact avatar"
                className="h-10 w-10 rounded-full bg-primary-blue/10"
              />
              <div>
                <div className="font-SFPro text-lg font-semibold">
                  {phone_number}
                </div>
                <div className="font-inter text-xs text-gray-500">
                  First contact: 1/25/2025
                </div>
              </div>
            </div>
            <button
              onClick={closeShowMessageIntent}
              className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300"
            >
              <CloseIcon className="h-3 w-3 text-black" aria-hidden="true" />
              <span className="sr-only">Close</span>
            </button>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto px-6 py-5">
            {/* Top insight cards */}
            <div className="grid gap-4 md:grid-cols-3">
              {/* Intent */}
              <div className="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-3">
                <img
                  src={IntentSVG}
                  alt="Intent"
                  className="mt-1 h-6 w-6"
                />
                <div>
                  <div className="font-SFPro text-sm font-semibold text-gray-900">
                    Intent
                  </div>
                  <span className="mt-1 inline-flex rounded-full bg-red-600 px-2.5 py-0.5 text-xs font-medium text-white">
                    {this.props.messageSentiment?.message_intent || "NA"}
                  </span>
                </div>
              </div>

              {/* Language */}
              <div className="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-3">
                <img
                  src={LanguageSVG}
                  alt="Language"
                  className="mt-1 h-6 w-6"
                />
                <div>
                  <div className="font-SFPro text-sm font-semibold text-gray-900">
                    Language
                  </div>
                  <div className="mt-1 text-sm text-gray-800">
                    {this.props.messageSentiment?.language || "NA"}
                  </div>
                </div>
              </div>

              {/* Sentiment */}
              <div className="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-3">
                <div className="mt-1 h-6 w-6">
                  {this.renderSentimentSVG(
                    this.props.messageSentiment?.sentiment
                  )}
                </div>
                <div>
                  <div className="font-SFPro text-sm font-semibold text-gray-900">
                    Sentiment
                  </div>
                  <div className="mt-1 text-sm text-gray-800">
                    {this.props.messageSentiment?.sentiment || "NA"}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 space-y-5">
              {/* Message Summary */}
              <div>
                <button type="button">
                  <div className="font-SFPro text-sm font-semibold text-blue-800">
                    Message Summary
                  </div>
                </button>
                <div className="mt-2 flex w-full items-stretch">
                  <div className="w-[6px] rounded-l-md bg-primary-blue" />
                  <div className="flex-1 border border-gray-200 bg-gray-50 px-3 py-3 font-inter text-sm text-gray-900">
                    {messageSummaryForOverview?.summary || "No summary"}
                  </div>
                </div>
              </div>

              {/* Message */}
              <div>
                <button type="button" onClick={showMessageHistory}>
                  <div className="font-SFPro text-sm font-semibold text-blue-800">
                    Message
                  </div>
                </button>
                <div className="mt-2 flex w-full items-stretch">
                  <div className="w-[6px] rounded-l-md bg-primary-blue" />
                  <div className="flex-1 border border-gray-200 bg-gray-50 px-3 py-3 font-inter text-sm text-gray-900">
                    {this.props.message}
                  </div>
                </div>
              </div>

              {/* Auto Response */}
              <div>
                <button type="button" onClick={() => showAIResponse()}>
                  <div className="font-SFPro text-sm font-semibold text-blue-800">
                    Auto Response
                  </div>
                </button>
                <div className="mt-2 flex w-full items-stretch">
                  <div className="w-[6px] rounded-l-md bg-primary-blue" />
                  <div className="flex-1 border border-gray-200 bg-gray-50 px-3 py-3 font-inter text-sm text-gray-900">
                    {this.props.fetchedIndividualAIResponse?.response ||
                      "No response, Please generate a response"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t border-gray-200 px-6 py-4">
            <button
              onClick={() => this.navigateToMessage(phone_number)}
              className="flex w-full items-center justify-center rounded-full bg-primary-blue px-4 py-3 font-SFPro text-sm font-semibold text-white shadow-sm hover:bg-blue-700"
            >
              Reply Message
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  messageSentiment: state.messaging.messageSentiment,
  message: state.messaging.message,
  messageSentiment: state.messaging.messageSentiment,
  fetchedIndividualAIResponse: state.messaging.fetchedIndividualAIResponse,
  messageSummaryForOverview: state.messaging.messageSummaryForOverview,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    GetMessageSentiment,
    GetIndividualAIResponse,
    GenerateMessageSummary,
  })(ShowMessageIntent)
);
